import React from 'react'
import classNames from 'classnames'
import { gsap, ScrollTrigger } from 'gsap/all'

import TitleCredits from './title-credits'
import { BackgroundColorContext } from './chapter'

gsap.registerPlugin(ScrollTrigger)

class ParallaxBackground extends React.Component {
    constructor(props) {
        super(props)

        this.domRef = React.createRef()
    }

    componentDidMount() {
        // Set up parallax background animation.
        this.domRef.current.style.backgroundPosition = `50% ${-this.domRef.current.offsetHeight / 2}px`

        document.addEventListener('allimagesloaded', () => {
            gsap.to(this.domRef.current, {
                backgroundPosition: `50% ${this.domRef.current.offsetHeight / 2}px`,
                ease: 'none',
                scrollTrigger: {
                    trigger: this.domRef.current,
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: true
                }
            })
        })
    }

    render() {
        const {
            backgroundImageRef,
            backgroundColor,
            darkenedBackground,
            textColor,
            minHeight, 
            noMargin,
            title,
            artist,
            year,
            credit,
            children
        } = this.props

        const style = {
            backgroundImage: 'url(\'' + backgroundImageRef + '\')',
            backgroundColor: backgroundColor,
            color: textColor,
            minHeight: minHeight,
            margin: noMargin && 'unset'
        }

        return (
            <div className={!children && 'parallax-background-container'} style={{margin: noMargin && 'unset'}}>
                <div 
                    className={classNames('parallax-background', (backgroundImageRef || backgroundColor) && 'has-background', darkenedBackground && 'darkened-background' )} 
                    style={style} 
                    ref={this.domRef}
                >
                    <BackgroundColorContext.Provider value={backgroundColor}>
                        {children}
                    </BackgroundColorContext.Provider>
                </div>
                {title &&
                    <TitleCredits 
                        title={title} 
                        artist={artist} 
                        year={year} 
                        credit={credit} 
                    />
                }
            </div>
        )
    }
}

export default ParallaxBackground